"use client";

import { useEffect } from "react";

import { NativeScreenReady } from "@/providers/native/splash-screen-provider";

/**
 * Route-level boundary. Without one, anything thrown during render tears the
 * whole tree down — in a static export that surfaces as the WebView's blank
 * "This page couldn't load" screen, with no clue as to why.
 */
export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Unhandled render error:", error);
  }, [error]);

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center">
      <NativeScreenReady />
      <div className="flex flex-col gap-1">
        <h1 className="text-lg font-semibold text-auth-foreground">
          Something went wrong
        </h1>
        <p className="text-sm text-auth-foreground/80">
          The screen could not be displayed. Try again, and if it keeps
          happening please report it.
        </p>
      </div>
      <button
        type="button"
        onClick={reset}
        className="inline-flex h-11 items-center justify-center rounded-lg bg-primary px-6 text-sm font-semibold text-primary-foreground"
      >
        Try again
      </button>
    </main>
  );
}
